// import UtilService from '@/services/utilService.js'
// import forecastingProfileApi from '@/api/forecastingProfileApi'
// eslint-disable-next-line no-unused-vars
import cropworkActivityApi from '@/api/cropworkActivityApi'

export default {
    namespaced: true,
    state: {
        loadingDepartmentCodes: false,
        loadingActivities: false,
        departmentCodes: [],
        divisions: [],
        productCategories: [],
        activities: [],
    },
    getters: {
        getDepartmentCodeLoadState(state){
            return state.loadingDepartmentCodes;
        },
        getActivitiesLoadState(state){
            return state.loadingDepartmentCodes && state.loadingActivities;
        },
        getDepartmentCodes(state){
            return state.departmentCodes;
        },
        getDivisions(state){
            return state.divisions;
        },
        getProductCategories(state) {
            return state.productCategories;
        }
    },
    mutations: {
        updateDepartmentCodeLoadState(state, value) {
            state.loadingDepartmentCodes = value;
        },
        updateActivityLoadState(state, value) {
            state.loadingActivities = value;
        },
        updateDepartmentCodes(state, value) {
            state.departmentCodes.splice(0, state.departmentCodes.length, ...value)
        },
        updateDivisions(state, value) {
            state.divisions.splice(0, state.divisions.length, ...value);
        },
        updateProductCategories(state, value) {
            state.productCategories.splice(0, state.productCategories.length, ...value);
        }, 
        updateActivities(state, value) {
            state.activities.splice(0, state.activities.length, ...value)
        },
    },
    actions: {
        async loadActivityDepartmentCodesAsync({commit}, options){
            commit('updateDepartmentCodeLoadState', true)
            const [departmentCodes, divisions, productCategories] = await Promise.all([
                cropworkActivityApi.getDepartmentCodes(options.plantID),
                cropworkActivityApi.getDivisions(options.plantID),
                cropworkActivityApi.getProductCategories(options.plantID)
            ])
            commit('updateDepartmentCodes', departmentCodes)
            commit('updateDivisions', divisions)
            commit('updateProductCategories', productCategories)
            commit('updateDepartmentCodeLoadState', false)
        },
        async loadCropWorkActivitiesAsync({commit}, options) 
        {
            commit('updateActivityLoadState', true)
            const activities = await cropworkActivityApi.getActivities(options.plantID);
            commit('updateActivities', activities)
            commit('updateActivityLoadState', false)
        }
    }
}